<template>
  <div class="p-4 bg-white">
    <vx-card class="progrm-form px-8 py-4">
      <iframe
        class="w-full"
        height="500"
        src="https://brained-app.freshdesk.com/support/home"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </vx-card>
  </div>
</template>

<script>
import "../../scss/Index.scss";
export default {};
</script>
